import axios from 'axios';
import { 
          ALL_POKEMONS_REQUEST,
          ALL_POKEMONS_SUCCESS,
          ALL_POKEMONS_FAIL,

          CLEAR_ERRORS
} from "../constants/allPokemonConstants"


   export const getAllPokemons = () =>{
                    return async(dispatch) => {
         try{

             dispatch({type:  ALL_POKEMONS_REQUEST})
           
             let temp=[]

             const fetchAllPokemons = async () => {

               const baseUrl = 'https://pokeapi.co/api/v2/pokemon';
    
                // const res = await fetch(`${baseUrl}?limit=4`)
                const res = await fetch(`${baseUrl}?limit=20`)

                const data = await res.json()
    
               //_____________________create function to fetch and create objects from each iteration

                   const pokemonObjects = (results) =>  {
                       
                     results.forEach(async(pokemon) => {
                         const res = await fetch(`${baseUrl}/${pokemon.name}`)
                         const data =  await res.json()

                             temp.push(data)

                             let storePokemon = temp.map((el)=> el)
                        
                            dispatch({
                              type: ALL_POKEMONS_SUCCESS, 
                              payload:   storePokemon
                             })    
                     })
                  }
                  pokemonObjects(data.results)
            }
            fetchAllPokemons()   
            
        }
         catch(error){

              console.log(error)

              dispatch({
                      type:  ALL_POKEMONS_FAIL,
                      payload: error.response.data.message
                   }
              )
         }
      }
   }


      

//___clear errors

export const clearErrors = () => async (dispatch) => {
  dispatch({
      type: CLEAR_ERRORS
  })
}





